import {
  FolderKanban,
  BriefcaseBusiness,
  CheckCircle2,
  Clock3,
  Users,
  Flag,
  TrendingUp,
} from "lucide-react";

const StatCard = ({
  title,
  value,
  icon: Icon,
  iconBg,
  iconColor,
}) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">

      <div className="flex items-start justify-between">

        <div>

          <p className="text-sm text-slate-500">
            {title}
          </p>

          <h2 className="mt-1 text-2xl font-bold text-slate-900">
            {value}
          </h2>

        </div>

        <div
          className={`flex h-10 w-10 items-center justify-center rounded-lg ${iconBg}`}
        >
          <Icon
            size={20}
            className={iconColor}
          />
        </div>

      </div>

    </div>
  );
};

const DashboardStats = ({
  projects = [],
}) => {

  const totalProjects =
    projects.length;

  const activeProjects =
    projects.filter(
      (project) =>
        project.status === "Active"
    ).length;

  const completedProjects =
    projects.filter(
      (project) =>
        project.status === "Completed"
    ).length;

  const onHoldProjects =
    projects.filter(
      (project) =>
        project.status === "On Hold"
    ).length;

  return (

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">

      <StatCard
        title="Total Projects"
        value={totalProjects}
        icon={FolderKanban}
        iconBg="bg-blue-100"
        iconColor="text-blue-600"
      />

      <StatCard
        title="Active Projects"
        value={activeProjects}
        icon={BriefcaseBusiness}
        iconBg="bg-emerald-100"
        iconColor="text-emerald-600"
      />

      <StatCard
        title="Completed"
        value={completedProjects}
        icon={CheckCircle2}
        iconBg="bg-violet-100"
        iconColor="text-violet-600"
      />

      <StatCard
        title="On Hold"
        value={onHoldProjects}
        icon={Clock3}
        iconBg="bg-orange-100"
        iconColor="text-orange-600"
      />

      {/* <StatCard
        title="Team Members"
        value="—"
        icon={Users}
        iconBg="bg-cyan-100"
        iconColor="text-cyan-600"
      /> */}

      


    </div>
  );
};

export default DashboardStats;